




















































import { Component, Mixins } from "vue-property-decorator";
import FormValidator from "@/mixins/FormValidator";
import { AuthModule } from "@/store/auth.module";
import { BaseModule } from "@/store/base.module";

@Component({})
export default class ForgotPasswView extends Mixins(FormValidator) {
  email: string = "";
  formRef = "form";
  loading: boolean = false;
  public async runRestorePassw() {
    if (!this.validateForm()) return;
    try {
      this.loading = true;
      const res = await AuthModule.restorePassword({
        email: this.email,
        recaptchaToken: await this.recaptcha("/restorePassword"),
      });
      if (res && res.result !== true) {
        BaseModule.showMessage({ message: res.message || "", color: "error" });
        return;
      }
      this.$router.push({ name: "warningRestore" });
    } finally {
      this.loading = false;
    }
  }
  async recaptcha(action: string) {
    await this.$recaptchaLoaded();
    return await this.$recaptcha(action);
  }

  public async clickBack() {
    this.$router.push({ name: "auth" });
  }
}
